import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SingleSelectDropdownModule } from 'Angular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class HoldingsAllHoldingsDatePickerModule {
}
HoldingsAllHoldingsDatePickerModule.ɵfac = function HoldingsAllHoldingsDatePickerModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsAllHoldingsDatePickerModule)(); };
HoldingsAllHoldingsDatePickerModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HoldingsAllHoldingsDatePickerModule });
HoldingsAllHoldingsDatePickerModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, SingleSelectDropdownModule, IconModule] });
